import { render } from "./a-fumbi-socials.vue?vue&type=template&id=6a3483f2&scoped=true"
import script from "./a-fumbi-socials.vue?vue&type=script&lang=js"
export * from "./a-fumbi-socials.vue?vue&type=script&lang=js"

import "./a-fumbi-socials.vue?vue&type=style&index=0&id=6a3483f2&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3483f2"]])

export default __exports__